
LocaleFields.$inject = ['$scope', '__env', 'toastr', 'httpService', 'readCookie'];angular
	.module('app')
	.component('localeFieldsComponent', {
		templateUrl: 'modules/localization/components/localefields/localeFields.html',
		controller: LocaleFields
	});

/**
 * Code supporting the kendo grid that displays LocaleSections
 * and performs CRUD opperations
 *
 * @class Locales
 * @param { service } $scope - The scope of the component.
 * @param { service } __env - The environment configuration. 
 * @param { service } toastr - The third party toaster service.
 * @param { service } httpService - The http service used to make asynchronous rest calls
 * @param { service } readCookie - reads cookie variables
 */
function LocaleFields($scope, __env, toastr, httpService, readCookie) {	 	

	// columns of the grid
	var columns = [
		{
			field: 'sectionCode',
			title: 'Section Code',
			width: '25%'
		},
		{
			field: 'fieldCode',
			title: 'Field Code',
			width: '25%'
		},		 
		{
			field: 'description',
			title: 'Description',
			width: '50%'
		}		
	];

	$scope.pageTitle = 'Locale Fields';

	$scope.localeFieldsOptions = { 
        columnMenu: false,        
        columns: columns,        
        editable: 'popup',   
        filterable: {
            extra: false,
            operators: {
                string: {
                    contains: 'Contains',
                    eq: 'Is equal to'
                }
            }
        },        
        groupable: false,        
        pageable: true,                
        scrollable: true,          
        sortable: true       
    };	

    // commented until the endpoints exist
    $scope.localeFieldsSource = 
    {	
    	//data: categories		
    	type: 'aspnetmvc-ajax',
        error: function(e) { toastr.error('Could not get locale fields');},	        
		transport: {
			read: {				
				type: 'get',		
				contentType: 'application/json',	
				url: __env.apiBaseUrlLocalization + '/localefields/paged/kendo',
				beforeSend: function(req) {
				           req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
				       },					              
			}
		},			
		schema: {
            data: 'data',
            total: 'total',                                   
        },                        
        pageSize: 10,                
        serverPaging: true,
        serverSorting: true,
        serverFiltering: true        
	};
}